import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerMarketingTrustpilotTestimonialsView } from "@faire/web-api--source/events/retailerMarketing/view/trustpilotTestimonials";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
import styled from "styled-components";
/**
 * Threshold above which we want to show a 5 star rating.
 * https://support.trustpilot.com/hc/en-us/articles/201748946-TrustScore-and-star-rating-explained
 */ var FIVE_STAR_THRESHOLD = 4.8;
var HIDDEN_THRESHOLD = 4.3;
export var TrustPilotWidget = function(param) {
    var rating = param.rating;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isSSR = useIsSSR();
    var viewRef = useDoActionWhenVisible(trackRetailerMarketingTrustpilotTestimonialsView);
    var logoUrl = "https://cdn.faire.com/fastly/ada8dc96a97da8d62daa0f30db77b7cb94f42027500f36bcb78ad107fc09fd4d.png";
    var ratingUrl = rating >= FIVE_STAR_THRESHOLD ? "https://cdn.faire.com/fastly/029be93298cd3d5e5d8ef06c06387d3cf3c41506f4da5f87b59b628a8655e6b8.png" : "https://cdn.faire.com/fastly/ddf78fe5f8bd0d64d1156f6af68388551e44aeb902613bdeb544be786e55af9d.png";
    if (rating < HIDDEN_THRESHOLD) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        ref: viewRef,
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "vcmnwb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Rated "
                        },
                        {
                            type: 8,
                            value: "b",
                            children: [
                                {
                                    type: 0,
                                    value: "\u2018Excellent\u2019"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " on"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        b: BoldFormatting
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(RatingImage, {
                alt: strictLocalize({
                    id: "Nbu6+K",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Widget showing Faire's TrustPilot score of "
                        },
                        {
                            type: 1,
                            value: "numberScore"
                        }
                    ]
                }, DEPRECATED_backwardsCompatibleValues({
                    numberScore: rating
                })),
                width: 120,
                height: 24,
                src: optimizeImageUrl(IImage.build({
                    width: 120,
                    height: 24,
                    url: ratingUrl
                }), isSSR)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: 0,
                    tabletAndAbove: "1x"
                }
            }),
            /*#__PURE__*/ _jsx("img", {
                alt: strictLocalize({
                    id: "H3FiUl",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Image of the Trustpilot Logo"
                        }
                    ]
                }),
                style: {
                    width: "80px",
                    height: "20px"
                },
                src: optimizeImageUrl(IImage.build({
                    width: 80,
                    height: 20,
                    url: logoUrl
                }), isSSR)
            })
        ]
    });
};
var BoldFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx("b", {
        children: chunks
    });
};
var RatingImage = styled.img.withConfig({
    componentId: "sc-107e17c-0"
})([
    "",
    "{display:none;}"
], responsiveMediaQueries.mobile);
